module.exports = __webpack_public_path__ + "static/media/donateIcon.a426ebac.webp";